import React, { useContext, useEffect, useRef, useState } from "react";
import ProductItems from "./ProductItems";
import ProductContext from "../Context/productContext";
import './Products.css'

const Products = ({setAlertMessage,setShowAlert}) => {
  const context = useContext(ProductContext);
  const { products, fetchAllProduct, editProduct } = context;
  const [imageSrc,setImageSrc]= useState({
    image:undefined
  });
  const [error,setError] = useState('');
  const closeRef=useRef();
  useEffect(() => {
    fetchAllProduct();
  }, []);

  const [product, setProduct] = useState({
    id: "",
    ecode:'',
    etitle: "",
    edescription:"",
    esize:"",
    estock:"",
    eprice: "",
    especialprice: "",
    ecolor: "",
    ecategory: "",
    eimage: "",
    imageUrl :""
  });

  

  //   Changing Values in textfield
  const onChange = (e) => {
    setProduct({ ...product, [e.target.name]: e.target.value });
  };

  const changeImageHandler = (e) => {
    setProduct({ ...product, eimage: e.target.files[0] });

    const reader = new FileReader();
        reader.onload = () => {
          if (reader.readyState === 2) {
            setImageSrc({
              image: reader.result,
            });
          }
        };
        reader.readAsDataURL(e.target.files[0]);
  };


  const updateProduct = (currentProduct) => {
    setProduct({
      id: currentProduct.id,
      ecode:currentProduct.productcode,
      etitle: currentProduct.title,
      edescription:currentProduct.description,
      esize:currentProduct.size,
      estock:currentProduct.stock,
      eprice: currentProduct.price,
      especialprice: currentProduct.specialprice,
      ecolor: currentProduct.color,
      ecategory: currentProduct.category,
      eimage: currentProduct.image,
      imageUrl : currentProduct.image
    });
  };

  const handleClick = (e) => {
    e.preventDefault();
    if(product.etitle&&product.eprice&&product.especialprice&&product.ecolor&&product.ecategory&&product.eimage){
      editProduct(
        product.id,
        product.ecode,
        product.etitle,
        product.edescription,
        product.esize,
        product.estock,
        product.eprice,
        product.especialprice,
        product.ecolor,
        product.ecategory,
        product.eimage,
        product.imageUrl
      );
      
      setAlertMessage('Product Updated Successfully');
      setShowAlert(true);
      setError('');
      setImageSrc({image:undefined})
      closeRef.current.click();
    }
    else{
      setError('Fill All the Details')
    }
  
  };

  return (
    <>
      <div
        className="modal fade"
        id="editModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Edit Product
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={closeRef}
              ></button>
            </div>
            <div className="modal-body">
              <div className="modal-row">
                <div className="col">
                  <form>
                  <div className="mb-3">
                      <label htmlFor="ecode" className="form-label">
                        Product Code
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="ecode"
                        name="ecode"
                        value={product.ecode}
                        onChange={onChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="etitle" className="form-label">
                        Product Title
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="etitle"
                        name="etitle"
                        value={product.etitle}
                        onChange={onChange}
                      />
                    </div>

                    <div className="mb-3">
                    <label htmlFor="edescription" className="form-label">
                        Description
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="edescription"
                        name="edescription"
                        value={product.edescription}
                        onChange={onChange}
                      />
                    
                      </div>

                      <div className="mb-3">
                      <label htmlFor="esize" className="form-label">
                        Size
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="esize"
                        name="esize"
                        value={product.esize}
                        onChange={onChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="estock" className="form-label">
                        Stock
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="estock"
                        name="estock"
                        value={product.estock}
                        onChange={onChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="eprice" className="form-label">
                        Price
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="eprice"
                        name="eprice"
                        value={product.eprice}
                        onChange={onChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="especialprice" className="form-label">
                        Special Price
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="especialprice"
                        name="especialprice"
                        value={product.especialprice}
                        onChange={onChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="ecolor" className="form-label">
                        Colour
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="ecolor"
                        name="ecolor"
                        value={product.ecolor}
                        onChange={onChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="ecategory" className="form-label">
                        Select Category
                      </label>

                      <select
                        className="form-select"
                        aria-label="Default select example"
                        id="ecategory"
                        name="ecategory"
                        onChange={(e) => {
                          setProduct({
                            ...product,
                            [e.target.name]: e.target.value,
                          });
                        }}
                        value={product.ecategory}
                      >
                        <option selected>---</option>
                        <option value="men">Men</option>
                        <option value="women">Women</option>
                      </select>
                    </div>

                    <div className="mb-3">
                      <label for="eformFile" className="form-label">
                        Select Images
                      </label>
                      <input
                        className="form-control"
                        type="file"
                        id="eformFile"
                        name="eimage"
                        accept="image/*"
                        onChange={(e) => changeImageHandler(e)}
                      />
                    </div>
                    <p style={{color:'red'}}>{error}</p>
                  </form>
                </div>
                <div className="col">
                  <div className="container">
                    <div className="img-container">
                      {/* {image.imageSrc === "" ? (
                        <h3 style={{ position: "relative", top: "50%" }}>
                          No Images Selected
                        </h3>
                      ) : ( */}
                      <img
                        src={imageSrc.image===undefined?product.eimage:imageSrc.image}
                        // src={product.eimage}
                        alt=""
                        style={{
                          height: "100%",
                          width: "100%",
                          objectFit: "cover",
                        }}
                      />
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={(e)=>{handleClick(e)
                }}
              >
                Update Product
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid" >
        <div className="product-grid-container">
          {products.map((item) => {
            return (
              <ProductItems
                key={item.id}
                item={item}
                updateProduct={updateProduct}
                setShowAlert={setShowAlert}
                setAlertMessage={setAlertMessage}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Products;
